export default __webpack_public_path__ + "static/media/picUnavailable.5ff31752.png";